export default __webpack_public_path__ + "static/media/coins.8109d699.jpeg";